<template>
	<ul>
		<li
			class="question-grid"
			:style="`border-top:1px solid ${$appColors.gray}`"
			v-for="(item, indexA) in answers"
			:key="indexA"
		>
			<span class="number" :style="`color:${$appColors.primary}`">
				{{indexA + 1}}.
			</span>
			<label for="question-name"
				:style="`color:${$appColors.info}`"
				class="name"
			>
				Nombre
				<input
					id="question-name"
					class="new-survey-input" 
					placeholder="Nombre"
					v-model="item.name"
				/>
			</label>
			<label for="question-number"
				:style="`color:${$appColors.info}`"
				class="value"
			>
				Valor
				<input
					id="question-number"
					class="new-survey-input" 
					placeholder="Valor"
					v-model.number="item.value"
				/>
			</label>
			<app-button
				:bg-color="$appColors.success"
				class="btn-tool icon-upload"
				text="Subir Ícono"
				@click="openIconModal(indexA, item.icon)"
			></app-button>
			<div class="icon-selected">
				<img
					v-if="item.icon.urlImage"
					:src="item.icon.urlImage"
					alt="ícono_seleccionado"
				>
			</div>
		</li>
	</ul>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import appButton from '@/components/shared/app-button';

function openIconModal(index, icon) {
	this.currentAnswerIndex = index;
	this.$store.dispatch('icon/selectIconAction', icon);
	this.goTo('answer-icon', { params: { index, type: 'ANSWER' } });
}

function urlIconHandler(newVal, oldVal) {
	const newOneExist = !!newVal;
	const oldOneExist = !!oldVal;
	const newUrlImage = newOneExist ? newVal.urlImage : '';
	const oldUrlImage = oldOneExist ? oldVal.urlImage : '';
	const isString = typeof newVal.urlImage === 'string';
	if (newOneExist && newUrlImage !== oldUrlImage && isString) {
		this.$store.dispatch('answer/updateAnswers', {
			index: this.currentAnswerIndex,
			icon: newVal,
		});
	}
}

function data() {
	return {
		currentAnswerIndex: 0,
	};
}

export default {
	name: 'answer-form',
	components: {
		appButton,
	},
	computed: {
		...mapGetters('icon', [
			'urlIcon',
		]),
		...mapState('icon', {
			selectedIcon: state => state.selectedIcon,
		}),
		...mapState('answer', {
			answers: state => state.partial.answers,
		}),
	},
	data,
	methods: {
		urlIconHandler,
		openIconModal,
	},
	watch: {
		// urlIcon: urlIconHandler,
		selectedIcon: {
			deep: true,
			handler: urlIconHandler,
		},
	},
};
</script>
<style lang="scss" scoped>
ul {
	height: 404px;
	overflow: auto;
	padding: 0;
	.question-grid {
		align-items: end;
		display: grid;
		grid-column-gap: 10px;
		grid-template-columns: 15px 1fr 50px 86px 35px 35px;
		padding: 20px 7px;

		.number {
			flex-basis: 5%;
		}

		.name {
			flex-basis: 45%;
		}

		.value, .icon-upload {
			flex-basis: 15%;
		}

		.value {
			input {
				padding: 6px;
			}
		}

		.icon-upload {
			font-family: font(regular);
			font-size: size(medium);
			height: 35px;
			margin: 0;
			width: max-content;
		}

		.icon-selected, .icon {
			align-items: center;
			border: 1px solid color(gray-slider);
			border-radius: 4px;
			display: flex;
			flex-basis: 10%;
			height: 35px;
			justify-content: center;
			width: 100%;

			img {
				height: 100%;
				width: 100%;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/answer/answer-form.vue